class NewsletterPopup extends HTMLElement {
  connectedCallback() {
    if (this.initialized) return;
    this.initialized = true;

    this.storageKey = `newsletter-popup:${this.dataset.sectionId}`;
    this.submittedKey = `${this.storageKey}:submitted`;
    this.delay = parseInt(this.dataset.delay, 10) * 1000;
    this.reappearDays = parseInt(this.dataset.reappearDays, 10);
    this.activeElementBeforeOpen = null;

    this.querySelectorAll('[data-popup-close]').forEach((button) => {
      button.addEventListener('click', this.close.bind(this));
    });

    this.addEventListener('keyup', (event) => {
      if (event.code === 'Escape') this.close();
    });

    // Shopify reloads the page after a customer form submit, and every newsletter
    // form on the page then reports success. Remember that this popup was the
    // sender so another form's submit doesn't reopen it.
    const form = this.querySelector('form');
    if (form) {
      form.addEventListener('submit', () => {
        try {
          sessionStorage.setItem(this.submittedKey, '1');
        } catch (error) {
          // Storage unavailable; the popup just won't reopen to show the success message.
        }
      });
    }

    if (this.querySelector('.newsletter-form__message--success')) {
      if (this.readStorage(sessionStorage, this.submittedKey)) {
        try {
          sessionStorage.removeItem(this.submittedKey);
        } catch (error) {
          // Ignore.
        }
        this.suppress(365);
        this.open();
      }
      return;
    }

    if (this.shouldShow()) {
      this.timeout = setTimeout(this.open.bind(this), this.delay);
    }
  }

  disconnectedCallback() {
    clearTimeout(this.timeout);
  }

  get designMode() {
    return Boolean(window.Shopify && window.Shopify.designMode);
  }

  readStorage(store, key) {
    try {
      return store.getItem(key);
    } catch (error) {
      return null;
    }
  }

  shouldShow() {
    // Always preview in the theme editor, ignoring any earlier dismissal.
    if (this.designMode) return true;

    const until = this.readStorage(localStorage, this.storageKey);
    return !until || Date.now() > parseInt(until, 10);
  }

  suppress(days) {
    if (this.designMode) return;

    try {
      localStorage.setItem(this.storageKey, Date.now() + days * 24 * 60 * 60 * 1000);
    } catch (error) {
      // Storage unavailable (private browsing): the popup shows again next visit.
    }
  }

  open() {
    this.activeElementBeforeOpen = document.activeElement;
    this.setAttribute('open', '');
    document.body.classList.add('overflow-hidden');

    const focusTarget = this.querySelector('input[type="email"]') || this.querySelector('[data-popup-close]');
    trapFocus(this, focusTarget);
  }

  close() {
    clearTimeout(this.timeout);
    this.removeAttribute('open');
    document.body.classList.remove('overflow-hidden');
    this.suppress(this.reappearDays);
    removeTrapFocus(this.activeElementBeforeOpen);
  }
}

customElements.define('newsletter-popup', NewsletterPopup);
